import { createFileRoute } from "@tanstack/react-router";
import { useEffect } from "react";

import { LinkedItemView } from "@/components/features/FileManager/LinkedItemView/LinkedItemView";
import { useBreadcrumb } from "@/hooks/useBreadcrumb";
import { getRouteIcon } from "@/utils/getRouteIconComponent";
import { MODULE_KEYS_MAP } from "@/api/permissions/permissions.types";

import styles from "../filesPage.module.scss";

export const Route = createFileRoute("/_authenticated/files/s/$token")({
  component: SharedLinkPage,
});

function useNoReferrer() {
  useEffect(() => {
    const meta = document.createElement("meta");
    meta.name = "referrer";
    meta.content = "no-referrer";
    document.head.appendChild(meta);
    return () => meta.remove();
  }, []);
}

function SharedLinkPage() {
  const { token } = Route.useParams();
  useNoReferrer();
  useBreadcrumb(
    [{ title: "Files", href: "/files", icon: getRouteIcon(MODULE_KEYS_MAP.files, 16) }],
    {},
  );

  return (
    <div className={styles.page}>
      <LinkedItemView token={token} />
    </div>
  );
}
